// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"up-z","slideIn":"vp-z"};